import PropTypes from 'prop-types';

export const ReportDataPropTypes = PropTypes.shape({
  name: PropTypes.string,
  orientation: PropTypes.string,
  editableColumns: PropTypes.arrayOf(PropTypes.object), // eslint-disable-line react/forbid-prop-types
  rows: PropTypes.arrayOf(PropTypes.shape({
    rowType: PropTypes.string,
    type: PropTypes.string,
    description: PropTypes.string,
    taxYear: PropTypes.string,
    taxYearForEditableChecks: PropTypes.string,
  })).isRequired,
  columnsCount: PropTypes.number,
});
